import useAxios from '../../utils/useAxios'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const getExpressPayments = createAsyncThunk('expresspayments/get', async (...args) => {
  try {
    const axios = useAxios()
    const { data } = await axios.get('/api/expresspayments/')
    return data
  } catch (error) {
    const { rejectWithValue } = args[1]
    // return custom error message from API if any
    if (error.response && error.response.data.detail) {
      return rejectWithValue(error.response.data.detail)
    } else {
      return rejectWithValue(error.message)
    }
  }
})

export const saveExpressPayment = createAsyncThunk(
  'expresspayment/save',
  async (expressPayment, { rejectWithValue }) => {
    try {
      const axios = useAxios()
      const { data } = await axios.put(`/api/expresspayments/${expressPayment.id}/`, expressPayment)
      return data
    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.detail) {
        return rejectWithValue(error.response.data.detail)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

export const createExpressPayment = createAsyncThunk(
  'expresspayment/create',
  async (expressPayment, { rejectWithValue }) => {
    try {
      const axios = useAxios()
      const { data } = await axios.post('/api/expresspayments/', expressPayment)
      return data
    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.detail) {
        return rejectWithValue(error.response.data.detail)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

export const deleteExpressPayment = createAsyncThunk(
  'expresspayment/delete',
  async (expressPayment, { rejectWithValue }) => {
    try {
      const axios = useAxios()
      const { data } = await axios.delete(`/api/expresspayments/${expressPayment.id}/`)
      return data
    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.detail) {
        return rejectWithValue(error.response.data.detail)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)
